import { ClassValue } from 'clsx';
import { ReactNode } from 'react';
import { ScrollView } from '@shared/components/View';
import { useFormScrollContext } from '@shared/scenes/entity/context';
import classNames from './FormScrollView.module.css';

/**
 * The scroll container for a card form, rendered by whatever owns the form's
 * pane (a modal route, the builder preview, an external page) — never by the
 * form itself, so there is always exactly one active scroller. It also paints
 * the form's gray ground, since the form sizes to its content.
 *
 * Binds the scrollable div to the FormScrollProvider ref so fields deeper in
 * the form (e.g. date pickers) can scroll it imperatively.
 */
export function FormScrollView({
  children,
  className,
}: {
  children: ReactNode;
  className?: ClassValue;
}) {
  const scrollView = useFormScrollContext();
  return (
    // Sized by ScrollView's default flex: 1 1 auto — a 0% basis (the `flex`
    // prop) collapses in Safari inside top-layer containers like the modals.
    <ScrollView ref={scrollView} fullWidth className={[classNames.formScroll, className]}>
      {children}
    </ScrollView>
  );
}
